import { render, staticRenderFns } from "./choose-list.vue?vue&type=template&id=22a6d6d4&scoped=true"
import script from "./choose-list.vue?vue&type=script&lang=js"
export * from "./choose-list.vue?vue&type=script&lang=js"
import style0 from "./choose-list.vue?vue&type=style&index=0&id=22a6d6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6d6d4",
  null
  
)

export default component.exports